// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 20 20" enableBackground="new 0 0 20 20" xmlSpace="preserve" fill="currentColor">
<path d="M5.73,14.92c-1.19,0-2.12,0.93-2.12,2.12c0,1.21,0.95,2.2,2.12,2.2c1.19,0,2.12-0.93,2.12-2.12
	C7.85,15.91,6.9,14.92,5.73,14.92z M6.45,17.05c0,0.39-0.34,0.73-0.73,0.73S5,17.44,5,17.05c0-0.39,0.34-0.72,0.73-0.72
	S6.45,16.66,6.45,17.05z"/>
<path d="M17.12,14.92c-1.19,0-2.12,0.93-2.12,2.12s0.93,2.12,2.12,2.12s2.12-0.93,2.12-2.12S18.32,14.92,17.12,14.92z M17.12,17.78
	c-0.39,0-0.72-0.34-0.72-0.73c0-0.39,0.34-0.72,0.72-0.72s0.72,0.34,0.72,0.72C17.85,17.44,17.51,17.78,17.12,17.78z"/>
<path d="M5.48,11.98v1.77c0,0.36,0.34,0.7,0.7,0.7h11.4c0.36,0,0.7-0.34,0.7-0.7s-0.34-0.7-0.7-0.7H6.95v-0.59l10.7-1.76
	c0.36,0,0.62-0.33,0.62-0.58l0.98-5.74c0-0.19,0-0.4-0.15-0.55C19,3.72,18.79,3.6,18.55,3.6H4.86L4.07,1.19
	C3.95,0.95,3.65,0.75,3.4,0.75H1.45c-0.36,0-0.7,0.34-0.7,0.7c0,0.42,0.32,0.77,0.7,0.77h1.39l0.76,2.29L5.48,11.98z M5.22,5.08
	h12.43l-0.74,4.33L6.74,11.07L5.22,5.08z"/>
</svg>;
};

export default React.memo(Cart);
